import OMOSettingsLayout from "../layout/OMOSettingsLayout";
import OMOPlayLogo from "../../assets/images/omoplay_logo_black.svg";
import KakaoLogo from "../../assets/images/kakao_channel_logo.svg";
import LineLogo from "../../assets/images/line_logo.svg";
import {Alert, Button, RadioGroup, TextInput} from "omoplay";
import KakaoAuthorization from "../form/message/KakaoAuthorization";
import {useState} from "react";
import ValidCheckForm from "../form/ValidCheckForm";
import {logout, postChannelRegistration} from "../../api/account/account.api";
import GuideButtonFrom from "../form/GuideButtonFrom";
import {checkChannel} from "../../api/channel/channel.api";

const ChannelRegistrationPage = () => {
    const [channelName, setChannelName] = useState("")
    const [channelIdName, setChannelIdName] = useState("")
    const [validChannelAuth, setValidChannelAuth] = useState(false)
    const [profileKey, setProfileKey] = useState(null)
    const [checkInviteAccount, setCheckInviteAccount] = useState(false)
    const [checkDuplicateChannel, setCheckDuplicateChannel] = useState(false)

    return (
        <OMOSettingsLayout title="채널 추가">
            <div>
                <div className="items-center">
                    <div className="flex-col gap-[32px] border bg-white p-[32px]" style={{borderRadius: "16px"}}>
                        <div className="flex justify-between">
                            <div className="w-[200px]">
                                <img alt="" src={OMOPlayLogo} />
                            </div>
                            <div>
                                <Button variants="secondary" value="로그아웃" onClick={() => logout()} />
                            </div>
                        </div>
                        <div className="text-[28px] font-bold">
                            환영합니다! 지금 채널을 추가하고<br/> 최고의 마케팅 파이프라인을 구축하세요
                        </div>
                        <div className="flex-col gap-1 mb-[12px]">
                            <div className="font-medium">채널 구분<span className="ml-1 text-red-500">*</span></div>
                            <div>
                                <RadioGroup items={[
                                    {
                                        label: (
                                            <div>
                                                <div className="flex gap-1">
                                                    <div><img src={KakaoLogo} alt="kakao" /></div>
                                                    <div className="font-medium">카카오 채널</div>
                                                </div>
                                                <div className="text-tertiary">카카오톡을 이용한 자사몰과의 연동</div>
                                            </div>
                                        ),
                                        value: "kakao"
                                    },
                                    {
                                        label: (
                                            <div>
                                                <div className="flex gap-1">
                                                    <div><img src={LineLogo} alt="line" /></div>
                                                    <div className="font-medium">라인 채널 (준비중)</div>
                                                </div>
                                                <div className="text-tertiary">라인을 이용한 자사몰과의 연동</div>
                                            </div>
                                        ),
                                        value: "line",
                                        disabled: true
                                    }
                                ]} onSelected={() => {}} />
                            </div>
                        </div>
                        <div className="flex-col gap-1">
                            <div className="flex">
                                <div className="text-[20px] font-bold">필요한 작업 (</div>
                                <div className="text-[20px] font-bold text-primary">{(validChannelAuth ? 1 : 0) + (checkInviteAccount ? 1 : 0)}</div>
                                <div className="text-[20px] font-bold">/2)</div>
                            </div>
                            <div className="font-medium">아래 항목을 펼쳐서 작업 내용을 확인하시고, 완료된 항목은 ‘체크' 해주세요</div>
                        </div>
                        <ValidCheckForm index={1} title="카카오 채널 관리자 인증이 필요합니다"
                                        checked={validChannelAuth}
                                        isOpen={!validChannelAuth}
                                        disabledCheckBox={true}
                        >
                            <div className="flex-col gap-2 p-[16px]">
                                <div className="flex-col gap-2 mb-[16px]">
                                    <div>아래의 신청 가이드를 먼저 확인해 주세요 ↓</div>
                                    <GuideButtonFrom buttonName="신청 가이드 - 카카오 채널 관리자 인증 방법"
                                                     url="https://omoplay.notion.site/NEW-App-25a2d9e7196a809e943ef4c286d0e1ac"
                                    />
                                </div>
                                <div className="flex-col gap-2">
                                    <div className="font-medium">채널 이름 (필수)</div>
                                    <div>
                                        <TextInput placeholder="채널 이름을 입력해 주세요."
                                                   disabled={validChannelAuth}
                                                   value={channelName}
                                                   onChange={(e) =>
                                                       setChannelName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="flex-col gap-2">
                                    <div className="font-medium">검색용 아이디 (필수)</div>
                                    <div>
                                        <TextInput placeholder="채널 목록에서 @뒤의 텍스트를 정확히 입력해 주세요"
                                                   disabled={validChannelAuth}
                                                   value={channelIdName}
                                                   onChange={(e) =>
                                                       setChannelIdName(e.target.value)}
                                                   onBlur={() => {
                                                       checkChannel(channelIdName).then(({data}) => {
                                                           setCheckDuplicateChannel(data)
                                                       })
                                                   }}
                                        />
                                    </div>
                                    {
                                        checkDuplicateChannel && (<div className="text-red-500">이미 등록된 채널입니다.</div>)
                                    }
                                </div>
                            </div>
                            <div className="flex-col gap-2 p-[16px]">
                                <KakaoAuthorization disabledAuthButton={checkDuplicateChannel || validChannelAuth}
                                                    showGuide={false}
                                                    channelIdName={channelIdName}
                                                    onSubmit={(profileKey) => {
                                                        setValidChannelAuth(true)
                                                        setProfileKey(profileKey)
                                                    }} />
                            </div>
                            <div className="p-[16px]">
                                <Alert title="카카오 채널 관리자 인증이 왜 필요한가요?" type="warning" withIcon={true}>
                                    <div className="pl-2">
                                        <li className="text-[13px]">카카오 채널의 소유권을 확인합니다.</li>
                                    </div>
                                </Alert>
                            </div>
                        </ValidCheckForm>
                        <ValidCheckForm index={2} title="카카오 채널에 오모플레이 계정을 팀원으로 초대해 주세요"
                                        isOpen={validChannelAuth}
                                        onChecked={(checked) => setCheckInviteAccount(checked)}
                        >
                            <div className="flex-col gap-2 p-[16px]">
                                <div>아래의 신청 가이드를 먼저 확인해 주세요 ↓</div>
                                <GuideButtonFrom buttonName="신청 가이드 - 카카오 채널에 오모플레이 계정 초대하기"
                                                 url="https://omoplay.notion.site/2332d9e7196a81389540de68148cfc8d"
                                />
                                <div className="bg-white text-center w-full p-[16px]">
                                    <div className="flex-cfont-semibold">
                                        <div>omoplay@kakao.com 계정을</div>
                                        <div>
                                            <span className="text-primary">카카오 비즈니스</span>
                                            {" "}관리자로 초대해 주세요.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ValidCheckForm>
                        <div className="flex justify-end">
                            <Button variants="primary" size="large" value="채널 추가 완료"
                                    disabled={!validChannelAuth || !checkInviteAccount}
                                    onClick={() =>
                                        postChannelRegistration(channelName, channelIdName, profileKey).then(({data}) => {
                                            localStorage.setItem("channelState", data)
                                            window.location.href = `/services`
                                        })
                            }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </OMOSettingsLayout>
    );
};
export default ChannelRegistrationPage;
